import api from '../../../App/socket';

export const getLeadsDivisions = ids => api.send({
    api: 'db',
    model: 'Lead_source',
    action: 'Read',
    options: {
        attributes: 'all',
        where: {
            _id: {
                $in: ids,
            },
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/get_leads_divisions_request.js